import { WebshopProduct } from '@cldsystems/ws-api-client';

export const findProductsBySkuAndLocale = (
  products: WebshopProduct[],
  skus: string[],
  locale: string,
): WebshopProduct[] => {
  const uniqueSkus = new Set(skus.filter(Boolean));

  if (uniqueSkus.size === 0) return [];

  const targetLocale = locale.toLowerCase();

  return products.filter(
    product => product.locale?.toLowerCase() === targetLocale && uniqueSkus.has(product.sku),
  );
};

export default findProductsBySkuAndLocale;
